module.exports = __webpack_public_path__ + "static/img/modules-girl.9f883c2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/modules-girl.png
// module id = SvRh
// module chunks = 1